import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-registro-exitoso',
  templateUrl: './registro-exitoso.component.html',
  styleUrls: ['./registro-exitoso.component.scss']
})
export class RegistroExitosoComponent implements OnInit {

  video: any;

  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {
  }

  clickModal(url: any): void {
    this.video = url;
    console.log(this.video);
    const modal = $('#myModal8');
    modal.css('display', 'block');
  }

  closeModal(): void {
    const modal = $('#myModal8');
    modal.css('display', 'none');
  }

  descarga(): void {
    window.open('https://triidyftp.s3.us-east-2.amazonaws.com/Triidy.rar', '_blank');
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    if (window.pageYOffset > 50) {
      let element = document.getElementById('navbar');
      element.classList.add('sticky');
    } else {
      let element = document.getElementById('navbar');
      element.classList.remove('sticky');
    }
  }


}
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'modal-welcome',
  templateUrl: 'modal-welcome.component.html',
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class ModalWelcome {
  constructor(public dialogRef: MatDialogRef<ModalWelcome>) { }
  /* onNoClick(): void {
    this.dialogRef.close();
  } */
}